<template lang="pug">
div
  .list(v-for="(l, i) in lists", :key="i")
    //- .type {{ l.category }}
    .item
      .logo
        BaseAvatar(
          :imgUrl="l.imgUrl",
          :title="l.eventName",
          style-list="width: 80px;height: 80px;border-radius: 50%;font-size:35px;"
        )
      .details
        .title
          router-link.name(
            :to="{ name: 'crisisDetails', query: { id: l.id } }",
            target="_blank"
          )
            div(v-html="l.eventName")
          .tags
            .tag.brand(v-for="t in l.brands") {{ t }}
            .tag.category(v-for="t in l.categories") {{ t }}
        .context(v-html="l.introduction")
        .startTime {{ l.startTime }}
      .operation
        //- .score {{ l.interveneScore }}
        //- span 公关传播效果指数
        .operations
          button(
            v-if="l.classify === 2",
            title="案例对比",
            :class="{ active: l.vs }",
            @click.prevent="compareEvent(l)"
          ) VS
          button.star(
            :class="{ active: l.hasCollect }",
            @click.prevent.stop="collect(l.id, !l.hasCollect)",
            :title="`${l.hasCollect ? '取消收藏' : '收藏'}`"
          )
            i.fa.fa-star
          router-link(
            :to="{ name: 'PdfViewer', params: { id: l.reportId } }",
            target="_blank",
            v-if="l.reportId"
          )
            button(title="预览报告")
              i.fa.fa-file
  .no-data(v-if="!lists.length")
    data-null
</template>

<script>
import client from '../server/server'
import _ from 'lodash'
import DataNull from '../components/DataNull'
import BaseAvatar from '@index/components/BaseAvatar.vue'
export default {
  name: 'CaseCollection',
  props: { lists: Array },
  components: {
    DataNull,
    BaseAvatar
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    time () {
      this.pages.now = 1
      this.getList()
    },
    compareIds: {
      deep: true,
      handler (val) {
        this.lists = this.lists.map(d => {
          return Object.assign({}, d, {
            vs: !!val.find(m => m.id === d.id)
          })
        })
      }
    }
  },
  methods: {
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeEventCollect(data)
        .then(res => {
          if (res.success) {
            this.lists.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    compareEvent (l) {
      let data = this.compareIds.slice()
      if (l.vs) {
        data = _.reject(data, d => d.id === l.id)
      } else {
        if (data.length > 1) {
          this.$message({
            message: '对比事件添加上限',
            type: 'warning',
            center: true
          })
          return false
        }
        data = data.concat(l)
      }
      this.$store.dispatch('updateCompareIds', data)
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .type {
    display: inline-block;
    margin: 4px;
    padding: 3px 6px;
    border-radius: 2px;
    background-color: #3989cb;
    color: #fff;
    font-size: 12px;
  }
  .item {
    display: flex;
    min-height: 150px;
    margin: 0 30px;
    border-bottom: 1px solid #f0f0f0;
    .logo {
      min-width: 80px;
      margin: 34px 30px 0 10px;
      img {
        width: 80px;
        height: 80px;
        background-color: #ffffff;
        border: solid 1px #e8ebf1;
        border-radius: 50%;
        display: block;
      }
    }
    .details {
      color: #888;
      font-size: 12px;
      flex: 1;
      .title {
        margin-top: 34px;
        display: flex;
        align-items: center;
        .name {
          color: #333;
          font-size: 14px;
        }
        .tags {
          margin-left: 23px;
          display: flex;
          align-items: center;
          .tag {
            margin-right: 10px;
            padding: 3px 6px;
            white-space: nowrap;
            &.brand {
              border-radius: 2px;
              background-color: rgba(1, 83, 206, 0.2);
              color: #025fea;
            }
            &.category {
              border-radius: 2px;
              background-color: rgba(80, 179, 87, 0.2);
              color: #50b357;
            }
          }
        }
      }
      .context {
        margin-top: 15px;
      }
      .startTime {
        margin-top: 10px;
      }
    }
    .operation {
      margin-left: 76px;
      margin-right: 10px;
      color: #666;
      font-size: 12px;
      text-align: center;
      .score {
        font-size: 24px;
        color: #f87653;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .operations {
        margin-top: 60px;
        button {
          width: 26px;
          height: 26px;
          border-radius: 4px;
          border: solid 1px #e8ebf1;
          background: #fff;
          margin: 0 5px;
          &.active {
            border: solid 1px #3989cb;
            background: #3989cb;
            color: #fff;
          }
          i {
            color: #999;
          }
          &.star {
            &.active {
              border: solid 1px #3989cb;
              background: #3989cb;
              .fa-star {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.no-data {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaseCollection/CaseCollectionList.vue